const TermsOfUse = () => {
  const downloadPDF = () => {
    import("html2pdf.js").then((html2pdf) => {
      const element = document.getElementById("content");
      const opt = {
        margin: 10,
        filename: "QMentisAI-Terms-of-Use.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };
      html2pdf.default().set(opt).from(element).save();
    });
  };

  return (
    <div style={styles.container}>
      {/* Download Button */}
      <div style={{ textAlign: "right", marginBottom: "20px" }}>
        <button id="downloadBtn" style={styles.downloadBtn} onClick={downloadPDF}>
          ⬇ Download PDF
        </button>
      </div>

      {/* Terms Content */}
      <div id="content">
        <h1 style={styles.h1}>Terms of Use</h1>
        <p style={styles.meta}>
          These Terms of Use (“Terms”) govern access to and use of the QMentisAI
          application, website(s), and related services provided by QualiZeal
          Inc. and its affiliates (“QualiZeal”, “we”, “us”, “our”). By accessing
          or using QMentisAI, the user accepts these Terms and our Privacy
          Policy. If the user does not agree, the user must not use QMentisAI.
        </p>

        <h2 style={styles.h2}>Definitions</h2>
        <p>
          <strong>“Application”</strong> means QMentisAI, including web, mobile,
          and API interfaces, documentation, and any associated content.
        </p>
        <p>
          <strong>“User Content”</strong> means data, prompts, stories,
          requirements, code, artifacts, or other materials submitted to or
          generated within the Application by or for the user.
        </p>
        <p>
          <strong>“Output”</strong> means AI- or automation-generated results
          produced by the Application from inputs, configurations, or
          integrations.
        </p>

        <h2 style={styles.h2}>Eligibility and Account</h2>
        <p>
          The Application is intended for professional and enterprise use by
          authorized users of QualiZeal or QualiZeal customers. Account
          creation, identity verification, and role-based access may be
          required.
        </p>
        <p>
          The user is responsible for safeguarding credentials and for all
          activities under the account. Notify QualiZeal immediately of
          suspected unauthorized use.
        </p>

        <h2 style={styles.h2}>Acceptable Use</h2>
        <p>The user agrees not to:</p>
        <ul>
          <li>
            Violate laws, infringe IP, or upload malicious code or content that
            is unlawful, harmful, or invasive.
          </li>
          <li>
            Attempt to reverse engineer, circumvent security, or exceed
            documented API or usage limits.
          </li>
          <li>
            Submit personal data without a lawful basis and notice/consent where
            required by applicable law.
          </li>
          <li>
            Use Output for critical decisions without appropriate human
            validation, testing, and governance.
          </li>
        </ul>

        <h2 style={styles.h2}>Integrations and Third-Party Services</h2>
        <p>
          QMentisAI may connect to third-party tools (e.g., CI/CD, test
          management, issue trackers) and relies on their APIs and terms; the
          user authorizes such integrations and remains responsible for
          third-party accounts and data flows.
        </p>

        <h2 style={styles.h2}>Intellectual Property</h2>
        <p>
          <strong>Application IP:</strong> QMentisAI, its models, frameworks
          (including agentic/RAG methods), and content are owned by QualiZeal or
          its licensors and are protected by law; no rights are granted except
          as expressly stated.
        </p>
        <p>
          <strong>User Content:</strong> Between the parties, the user retains
          rights in User Content; the user grants QualiZeal a limited license to
          host, process, and display User Content to operate, maintain, secure,
          and improve the Application, subject to confidentiality and privacy
          commitments.
        </p>
        <p>
          <strong>Output:</strong> Subject to payment and compliance with these
          Terms, QualiZeal assigns or licenses Output rights to the user to the
          extent permitted by law and third-party terms; the user is responsible
          for legal, security, and compliance validation of Output before
          production use.
        </p>

        <h2 style={styles.h2}>Confidentiality</h2>
        <p>
          Each party will protect the other’s non-public information with at
          least reasonable care and use it solely to perform under these Terms;
          exemptions apply for information that is public, independently
          developed, or rightfully received without duty.
        </p>

        <h2 style={styles.h2}>Data Protection and Security</h2>
        <p>
          QualiZeal will implement reasonable technical and organizational
          measures aligned with applicable laws and industry practices; breach
          notification will be provided consistent with legal requirements and
          contractual commitments.
        </p>

        <h2 style={styles.h2}>Disclaimers</h2>
        <p>
          QMentisAI employs AI and automation that may produce inaccuracies; the
          Application is provided “as is” without warranties of fitness,
          non-infringement, or error-free performance, to the maximum extent
          permitted by law. The user should apply human review, testing, and
          controls.
        </p>

        <h2 style={styles.h2}>Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, neither party is liable for
          indirect or consequential damages; QualiZeal’s aggregate liability
          arising from the Application shall not exceed the amounts paid for the
          service in the 12 months preceding the claim. These limits do not
          apply to willful misconduct or amounts that cannot be limited by law.
        </p>

        <h2 style={styles.h2}>Indemnity</h2>
        <p>
          The user will indemnify and hold harmless QualiZeal against claims
          arising from User Content, unlawful use, or violations of these Terms;
          QualiZeal will indemnify for claims alleging that the unmodified
          Application infringes third-party IP, subject to standard exclusions
          and procedures.
        </p>

        <h2 style={styles.h2}>Suspension and Termination</h2>
        <p>
          QualiZeal may suspend or terminate access for material breaches, legal
          risks, or security concerns; upon termination, access ceases, and
          QualiZeal will handle data export and deletion per the Privacy Policy
          and applicable law.
        </p>

        <h2 style={styles.h2}>Governing Law and Dispute Resolution</h2>
        <p>These Terms are governed by the laws of Texas, USA.</p>

        <h2 style={styles.h2}>Changes to Terms</h2>
        <p>
          QualiZeal may update these Terms; continued use after effective date
          constitutes acceptance. Material changes will be notified via the
          Application or email.
        </p>

        <h2 style={styles.h2}>Contact</h2>
        <p>
          For questions:{" "}
          <a href="mailto:aithinktank@qualizeal.com">
            aithinktank@qualizeal.com
          </a>{" "}
          or the contact channels listed on QualiZeal’s website.
        </p>

        <hr />
        <p style={styles.footer}>© QualiZeal Inc. All rights reserved.</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "Arial, Helvetica, sans-serif",
    maxWidth: "860px",
    margin: "40px auto",
    lineHeight: "1.6",
    padding: "0 16px",
  },
  h1: {
    fontSize: "1.9rem",
    marginBottom: "0.5rem",
    lineHeight: 1.25,
  },
  h2: {
    fontSize: "1.25rem",
    marginTop: "1.5rem",
    lineHeight: 1.25,
  },
  meta: {
    color: "#555",
    fontSize: "0.95rem",
    marginBottom: "1.2rem",
  },
  footer: {
    marginTop: "2rem",
    fontSize: "0.95rem",
    color: "#444",
  },
  downloadBtn: {
    backgroundColor: "#49A3FF",
    color: "white",
    border: "none",
    padding: "10px 18px",
    fontSize: "14px",
    borderRadius: "8px",
    cursor: "pointer",
    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
    transition: "background-color 0.3s ease, transform 0.2s ease",
  },
};

export default TermsOfUse;
